import { AccordionDetails, Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikErrors, FormikHandlers, FormikState } from 'formik';
import { AccountData } from '../../../api';
import { OrderPagesMultiSelect } from '../../../userSettings/OrderPagesMultiSelect';
import { Accordion, AccordionSummary } from '../../../calendar/dialogs/EditOrderDialog/components/Accordion';
import { StorefrontPanels } from '../StorefrontDrawer';

type FormWithTrialOrderPageIds = {
  trial_order_page_ids: string[];
};

type TrialOrderPagesPanelProps = {
  account: AccountData;
  values: FormWithTrialOrderPageIds;
  errors: FormikErrors<FormWithTrialOrderPageIds>;
  touched: FormikState<FormWithTrialOrderPageIds>['touched'];
  handleChange: FormikHandlers['handleChange'];
  setFieldValue: (field: string, value: any) => void;
  expanded?: StorefrontPanels;
  onPanelChange: (panel: StorefrontPanels) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
  panelName: StorefrontPanels;
};

export const TrialOrderPagesPanel = ({
  account,
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  expanded,
  onPanelChange,
  panelName,
}: TrialOrderPagesPanelProps) => {
  const { t } = useTranslation();

  return (
    <Accordion expandedPanelName={expanded} panelName={panelName} onChange={onPanelChange}>
      <AccordionSummary
        title={t('storefronts.trial_order_pages')}
        summaryComponent={<Typography variant="body2">{values.trial_order_page_ids?.length || 0}</Typography>}
      />
      <AccordionDetails>
        <Grid container flexDirection="column" gap={1}>
          <Typography variant="body2" color="text.secondary">
            {t('storefronts.drag_to_reorder', { activity: t('storefronts.trial_order_page') })}
          </Typography>

          <OrderPagesMultiSelect
            values={values}
            errors={errors}
            touched={touched}
            handleChange={handleChange}
            orderPagesFieldName="trial_order_page_ids"
            account={account}
            orderable
            setFieldValue={setFieldValue}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
